@for (toast of toastService.toasts | async; track toast) {
    <ngb-toast
            [header]="toast.header"
            [autohide]="true"
            [delay]="toast.delay || 5000"
            [class]="toast.classname || null"
            (hidden)="toastService.remove(toast)">
        <i *appDangerToast="toast.type=='danger'" class="bg-danger bi bi-exclamation-circle" style="font-size: 1rem;"></i>

        {{ toast.body }}
    </ngb-toast>
}
